import { toast } from "react-toastify";
import Typography from "antd/es/typography/Typography";
import i18n from "./i18n";
import i18next from "i18next";
import Jcb from "./assets/jcb.svg?react";
import Mada from "./assets/mada.svg?react";
import Maestro from "./assets/maestro.svg?react";
import Visa from "./assets/visa.svg?react";
import MasterCard from "./assets/mastercard.svg?react";
import Ryl from "../src/assets/ryl.svg?react"
import { Tooltip } from "antd";
import { CreditCardIcon } from "@heroicons/react/24/solid";

const language = i18n.language;
const lString = language=="en"?"en-US":"ar-EG";

export const isMobile = () => {
  const userAgent = navigator.userAgent || navigator.vendor ;
  return /android|iPad|iPhone|iPod/i.test(userAgent);
};

export const AmountRiyal = (value:any,hidesym?:boolean,red?:boolean,devide?:boolean,mod?:boolean)=>{
  
  return (
    <div className=" flex flex-row gap-x-2 items-center whitespace-nowrap  ">
    <Typography 
    style={{display:hidesym?"none":"block"}} className="text-gray-500 ">
    
  <Ryl width={10} />
  
   
    </Typography>
    
    {mod?<Typography className={getFontClass(`${red?"text-red-500":""}`,600)}>
      {value}
    </Typography>:<Typography className={getFontClass(`${red?"text-red-500":""}`,600)}>
    {devide ? Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : (value / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
    </Typography>}
  </div>
  )


}

export function isHexEncoded(value: string): boolean {
    if (!value || value.trim().length === 0) return false;
    // Match compact hex (D985D8B1) or space-separated hex (D9 85 D8 B1)
    return /^([0-9A-Fa-f]{2}\s*)+$/.test(value.trim());
}

export function hexToArabic(hex: string): string {
    // Strip spaces so both "D985" and "D9 85" work
    const compact = hex.replace(/\s+/g, '');
    // Insert '%' before every 2 characters (e.g., 'D8' becomes '%D8')
    const percentEncoded = compact.replace(/(..)/g, '%$1');
    try {
        return decodeURIComponent(percentEncoded);
    } catch {
        return hex; // fallback to raw if decode fails
    }
}


export const separateDateTime = (dateString: string) => {
  try {
    const date = new Date(dateString);
    
    const formattedDate = new Intl.DateTimeFormat(lString, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(date);
  
    const formattedTime = new Intl.DateTimeFormat(lString, {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(date);

    return {
      date: formattedDate,
      time: formattedTime
    };
    
  } catch (error) {
    console.log(error);
    return {
      date: dateString,
      time: ""
    };
  }
};




export const convertToArabicNumerals = (number: any): any => {
 
  const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  return number
    .toString()
    .split('')
    .map((digit:any) => (/\d/.test(digit) ? arabicNumerals[parseInt(digit)] : digit))
    .join('');
};



export const getFontClass = (baseClass: string,weight:number) => {
  // console.log(language === "en" ? `${baseClass} font-poppins-${weight.toString()}`: `${baseClass} font-alex-${weight.toString()}`);

  return language === "en" ? `${baseClass} en-${weight} `: `${baseClass} ar-${weight} ` ;
};



export const logoHandler = (name: string) => {
  switch (name) {
    case "Mada":
      return <Mada className="w-10 h-10" />;
      break;
      case "mada":
        return <Mada className="w-10 h-10" />;
        break;

    case "Jcb":
      return <Jcb className="w-10 h-10" />;
      break;

    case "MasterCard":
      case "mastercard":
        case "MASTERCARD":
      return <MasterCard className="w-10 h-10" />;
      break;

    case "Visa":
      case "VISA":
      return <Visa className="w-10 h-10" />;
      break;

      case "Maestro":
      case "MAESTRO":
        return <Maestro className="w-10 h-10" />;
        break;

        case "None":
          return <Typography className={getFontClass(" text-gray-500",600)} >
            None
          </Typography>;
          break;

          case "":
            return <Typography className={getFontClass(" text-gray-500",600)} >
              None
            </Typography>;
            break;

            case null:
              return <Typography className={getFontClass(" text-gray-500",600)} >
             <CreditCardIcon className="w-10 h-10" />
              </Typography>;
              break;

    default:
      return (
        <div>
       {name}
        </div>
      );
      break;
  }
};

export const formatDate = (dateString: string) => {
 
  try {
    const date = new Date(dateString);
    const formattedDate = new Intl.DateTimeFormat(lString, {
      year: "numeric",
      month: "short",
      day: "numeric",
    }).format(date);
  
    const formattedTime = new Intl.DateTimeFormat(lString, {
      hour: "2-digit",
      minute: "2-digit",
    }).format(date);

    return (
      <div>
        <Typography className={getFontClass("whitespace-nowrap text-xs ",500)}>
          {formattedDate}
        </Typography>
        <Typography className="whitespace-nowrap text-xs">{formattedTime}</Typography>
      </div>
    );
    
  } catch (error) {

  console.log(error);
  return (
    <div>
      <Typography className={getFontClass(" whitespace-nowrap ",500)}>
      {dateString}
      </Typography>
  
    </div>
  );
    
  }
 
};

export function handlePercent(number:number){

  return <Typography className={getFontClass("",500)}>
     {`${Number(number/100).toFixed(2)} %`}
  </Typography>

}


export function activeHandle (status:any){
  switch(status){
    case "ACTIVE":
      return (
        <Tooltip title={status}>
          <div className="flex justify-center cursor-help rounded-full max-w-28 items-center py-1 whitespace-nowrap px-2 border-green-500 border-2 ">
            <Typography className={getFontClass("text-xs text-green-500 ",500)}>
            {i18next.t("active")}
            </Typography>
          </div>
        </Tooltip>
      );
      break;

      case "INACTIVE":
        return (
          <Tooltip title={status}>
            <div className="flex justify-center cursor-help rounded-full max-w-28 items-center py-1 whitespace-nowrap px-2 border-red-500 border-2 ">
              <Typography className={getFontClass("text-xs text-red-500 ",500)}>
              {i18next.t("inactive")}
              </Typography>
            </div>
          </Tooltip>
        );
        break;
  }
}



export function statusHandler(status: string) {
  switch (status) {
    case "APPROVED":
      return (
        <Tooltip title={status}>
          <div className="flex justify-center cursor-help rounded-full max-w-28 items-center py-1 whitespace-nowrap px-2 border-green-500 border-2 ">
            <Typography className={getFontClass("text-xs text-green-500 ",500)}>
            {i18next.t("APPROVED")}
            </Typography>
          </div>
        </Tooltip>
      );
      break;

    case "INITIALIZED":
      return (
        <Tooltip title={status}>
          <div className="flex justify-center cursor-help rounded-full items-center max-w-28 py-1 whitespace-nowrap px-3 border-blue-500 border-2 ">
            <Typography className={getFontClass(" text-xs text-blue-500",500)}>
              {i18next.t("INITIALIZED")}
            </Typography>
          </div>
        </Tooltip>
      );
      break;
      case "CANCELED":
        return (
          <Tooltip title={status}>
            <div className="flex justify-center cursor-help rounded-full items-center max-w-28 py-1 whitespace-nowrap px-3 border-yellow-500 border-2 ">
              <Typography className={getFontClass(" text-xs text-yellow-500",500)}>
                {i18next.t("canceled")}
              </Typography>
            </div>
          </Tooltip>
        );
        break;

    case "TERMINAL NOT CONNECTED":
      return (
        <Tooltip title={status}>
          <div className="flex justify-center cursor-help  rounded-full items-center max-w-28 py-1 whitespace-nowrap px-3 border-gray-500 border-2 ">
            <Typography className={getFontClass(" text-xs text-gray-500",500)}>
            {i18next.t("TERMINAL_NOT_CONNECTED")}
            </Typography>
          </div>
        </Tooltip>
      );
      break;

  case "DECLINED":
      return (
        <Tooltip title={status}>
          <div className="flex justify-center cursor-help  rounded-full items-center max-w-28 py-1 whitespace-nowrap px-3 border-red-500 border-2 ">
            <Typography className={getFontClass(" text-xs text-red-500",500)}>
              {i18next.t("DECLINED")}
            </Typography>
          </div>
        </Tooltip>
      );
      break;
      case "TERMINAL_MISCONF":
        return (
        <Tooltip title={status}>
          <div className="flex justify-center cursor-help rounded-full items-center max-w-28 py-1 whitespace-nowrap px-3 border-orange-500 border-2 ">
            <Typography className={getFontClass(" text-xs text-orange-500", 500)}>
            {i18next.t("missconfiguration")}
            </Typography>
          </div>
        </Tooltip>
        );
        break;

      case "TIMEOUT":
        return (
        <Tooltip title={status}>
          <div className="flex justify-center cursor-help rounded-full items-center max-w-28 py-1 whitespace-nowrap px-3 border-purple-500 border-2 ">
          <Typography className={getFontClass(" text-xs text-purple-500", 500)}>
            {i18next.t("timeout")}
          </Typography>
          </div>
        </Tooltip>
        );
        break;

         case "ERROR":
        return (
        <Tooltip title={status}>
          <div className="flex justify-center cursor-help rounded-full items-center max-w-28 py-1 whitespace-nowrap px-3 border-purple-500 border-2 ">
          <Typography className={getFontClass(" text-xs text-purple-500", 500)}>
            {i18next.t("error")}
          </Typography>
          </div>
        </Tooltip>
        );
        break;

           case "FAILED":
        return (
        <Tooltip title={status}>
          <div className="flex justify-center cursor-help rounded-full items-center max-w-28 py-1 whitespace-nowrap px-3 border-purple-500 border-2 ">
          <Typography className={getFontClass(" text-xs text-purple-500", 500)}>
            {i18next.t("failed")}
          </Typography>
          </div>
        </Tooltip>
        );
        break;


    default:
      return (
        <Tooltip title={status}>
          <div
            className="flex justify-center cursor-help  rounded-full text-center max-w-28 whitespace-nowrap  items-center 
          py-1 px-1 border-gray-500  text-xs border-2 "
          >
            <Typography className={getFontClass("text-gray-500 ",500)}>
              {status?.substring(0, 6) + "..."}
            </Typography>
          </div>
        </Tooltip>
      );
      break;
  }
}


export const  providerStatusCode = (value:String)=>{

  switch (value) {
    case "00":
        return "transaction approved, account debited.";
    case "01":
        return "transaction declined for different reasons (including invalid PIN), account not debited.";
    case "02":
        return "transaction rejected, account not debited.";
    case "11":
        return "Cancelled by user, account not debited.";
    case "12":
        return "Void due to communication failure or some other reason, account not debited.";
    case "13":
        return "Card Not Supported";
    case "14":
        return "Transaction Not allowed";
    case "15":
        return "Expired Card";
    case "16":
        return "No Dial Tone (Phone line disconnected)";
    case "17":
        return "Card is not accepted.";
    case "18":
        return "Invalid MAC";
    case "86":
        return "Incorrect Refund Card";
    case "87":
        return "PIN locked.";
    case "88":
        return "PIN timeout.";
    case "89":
        return "Service is not accepted.";
    case "90":
        return "Card removed after PIN entry.";
    case "91":
        return "Card removed Before PIN entry";
    case "92":
        return "Card removed after sending request (ARQC check failed).";
    case "93":
        return "Card Timeout.";
    case "94":
        return "Invalid PIN.";
    case "95":
        return "Invalid Amount.";
    case "96":
        return "Invalid Card (Blocked Card)";
    case "97":
        return "EMV Application is Blocked";
    case "98":
        return "Transaction declined by Card";
    case "99":
        return "EMV Card not Detected by POS (Card not inserted into POS)";
    default:
        return "Unknown provider response code.";
}

}


function showToast(msg: string, type: string, time: number| false = 3000,hideProgressBar: boolean = true) {
  if (type === "error") {
    toast.error(msg, {
    position: "top-right",
    autoClose: time, 
    hideProgressBar: hideProgressBar,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    });
    
  } else if (type === "success") {
    toast.success(msg, {
      position: "top-right",
      autoClose: time, 
      hideProgressBar: hideProgressBar,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  else if (type === "warning") {
    toast.warning(msg, {
      position: "top-right",
      autoClose: time, 
      hideProgressBar: hideProgressBar,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
   
  }

  export const handleSwitchResponse = (code: any) => {
    const errorCodes: Record<string, { description: string; action: string }> = {
      '000': { description: 'Approved', action: 'Approve' },
      '001': { description: 'Honour with identification', action: 'Approve' },
      '003': { description: 'Approved (VIP)', action: 'Approve' },
      '007': { description: 'Approved, update ICC', action: 'Approve' },
      '087': { description: 'Offline Approved (Chip only)', action: 'Approve' },
      '089': { description: 'Unable to go On-line. Off-line approved (Chip only)', action: 'Approve' },
      '100': { description: 'Do not honour', action: 'Decline' },
      '101': { description: 'Expired card', action: 'Decline' },
      '102': { description: 'Suspected fraud (To be used when ARQC validation fails)', action: 'Decline' },
      '103': { description: 'Card acceptor contact acquirer', action: 'Decline' },
      '104': { description: 'Restricted card', action: 'Decline' },
      '105': { description: 'Card acceptor call acquirer\'s security department', action: 'Decline' },
      '106': { description: 'Allowable PIN tries exceeded', action: 'Decline' },
      '107': { description: 'Refer to card issuer', action: 'Decline' },
      '108': { description: 'Refer to card issuer\'s special conditions', action: 'Decline' },
      '109': { description: 'Invalid merchant', action: 'Decline' },
      '110': { description: 'Invalid amount', action: 'Decline' },
      '111': { description: 'Invalid card number', action: 'Decline' },
      '112': { description: 'PIN data required', action: 'Decline' },
      '114': { description: 'No account of type requested', action: 'Decline' },
      '115': { description: 'Requested function not supported', action: 'Decline' },
      '116': { description: 'Not sufficient funds', action: 'Decline' },
      '117': { description: 'Incorrect PIN', action: 'Decline' },
      '118': { description: 'No card record', action: 'Decline' },
      '119': { description: 'Transaction not permitted to cardholder', action: 'Decline' },
      '120': { description: 'Transaction not permitted to terminal', action: 'Decline' },
      '121': { description: 'Exceeds withdrawal amount limit', action: 'Decline' },
      '122': { description: 'Security violation', action: 'Decline' },
      '123': { description: 'Exceeds withdrawal frequency limit', action: 'Decline' },
      '125': { description: 'Card not effective', action: 'Decline' },
      '126': { description: 'Invalid PIN block', action: 'Decline' },
      '127': { description: 'PIN length error', action: 'Decline' },
      '128': { description: 'PIN key synch error', action: 'Decline' },
      '129': { description: 'Suspected counterfeit card', action: 'Decline' },
      '182': { description: 'Invalid date (Visa 80)', action: 'Decline' },
      '183': { description: 'Cryptographic error found in PIN or CVV (Visa 81)', action: 'Decline' },
      '184': { description: 'Incorrect CVV (Visa 82)', action: 'Decline' },
      '185': { description: 'Unable to verify PIN (Visa 83)', action: 'Decline' },
      '188': { description: 'Offline declined', action: 'Decline' },
      '190': { description: 'Unable to go online - Offline declined', action: 'Decline' },
      '195': { description: 'Individual transaction amount exceeds limit', action: 'Decline' },
      '196': { description: 'Cumulative contactless limit exceeded', action: 'Decline' },
      '200': { description: 'Do not honour', action: 'Decline' },
      '201': { description: 'Expired card', action: 'Decline' },
      '202': { description: 'Suspected fraud (To be used when ARQC validation fails)', action: 'Decline' },
      '203': { description: 'Card acceptor contact acquirer', action: 'Decline' },
      '204': { description: 'Restricted card', action: 'Decline' },
      '205': { description: 'Card acceptor call acquirer\'s security department', action: 'Decline' },
      '206': { description: 'Allowable PIN tries exceeded', action: 'Decline' },
      '207': { description: 'Special conditions', action: 'Decline' },
      '208': { description: 'Lost card', action: 'Decline' },
      '209': { description: 'Stolen card', action: 'Decline' },
      '210': { description: 'Suspected counterfeit card', action: 'Decline' },
      '300': { description: 'Successful', action: 'Approve' },
      '301': { description: 'Not supported by receiver', action: 'Decline' },
      '302': { description: 'Unable to locate record on file', action: 'Decline' },
      '306': { description: 'Not successful', action: 'Decline' },
      '307': { description: 'Format error', action: 'Decline' },
      '400': { description: 'Accepted', action: 'Approve' },
      '480': { description: 'Original transaction not found', action: 'Decline' },
      '481': { description: 'Original transaction was found but declined', action: 'Decline' },
      '500': { description: 'Reconciled, in balance', action: 'Approve' },
      '501': { description: 'Reconciled, out of balance', action: 'Decline' },
      '690': { description: 'Unable to parse message', action: 'Decline' },
      '800': { description: 'Accepted', action: 'Approve' },
      '888': { description: 'Unknown error', action: 'Decline' },
      '893': { description: 'Signature Error', action: 'Decline' },
      '902': { description: 'Invalid transaction', action: 'Decline' },
      '903': { description: 'Re-enter transaction', action: 'Re-enter transaction' },
      '904': { description: 'Format error', action: 'Decline' },
      '906': { description: 'Cutover in process', action: 'Decline' },
      '907': { description: 'Card issuer or switch inoperative', action: 'Decline' },
      '908': { description: 'Transaction destination cannot be found for routing', action: 'Decline' },
      '909': { description: 'System malfunction', action: 'Decline' },
      '910': { description: 'Card issuer signed off', action: 'Decline' },
      '911': { description: 'Card issuer timed out', action: 'Decline' },
      '912': { description: 'Card issuer unavailable', action: 'Decline' },
      '913': { description: 'Duplicate transmission', action: 'Decline' },
      '914': { description: 'Not able to trace back to original transaction', action: 'Decline' },
      '915': { description: 'Reconciliation cutover or checkpoint error', action: 'Decline' },
      '916': { description: 'MAC incorrect (permissible in 1644)', action: 'Decline' },
      '917': { description: 'MAC key sync', action: 'Decline' },
      '918': { description: 'No communication keys available for use', action: 'Decline' },
      '919': { description: 'Encryption key sync error', action: 'Decline' },
      '920': { description: 'Security software/hardware error - try again', action: 'Decline' },
      '921': { description: 'Security software/hardware error - no action', action: 'Decline' },
      '922': { description: 'Message number out of sequence', action: 'Decline' },
      '923': { description: 'Request in progress', action: 'Decline' },
      '940': { description: 'Unknown terminal', action: 'Decline' },
      '942': { description: 'Invalid Reconciliation Date', action: 'Decline' },
    };

    return errorCodes[code] || { description: '', action: 'Unknown' };
  };

 export const getPasswordStrength = (password: string): string => {
    let strength = 0;

    if (password.length >= 8) strength++;
    if (/[A-Z]/.test(password)) strength++;
    if (/[a-z]/.test(password)) strength++;
    if (/[0-9]/.test(password)) strength++;
    if (/[^A-Za-z0-9]/.test(password)) strength++;

    if (strength <= 2) return "Weak";
    if (strength === 3 || strength === 4) return "Medium";
    return "Strong";
  };



  export default showToast